export default __webpack_public_path__ + "static/media/female-avatar.ec97a9f3.png";